module.exports = __webpack_public_path__ + "static/img/mall.87d7a66e.png";